module.exports = __webpack_public_path__ + "img/Winner-2.60dd81e4.jpg";